<template>
  <div v-if="viewMode === 'list'" class="row">
    <div
      v-for="(option, index) in menu"
      :key="index"
      class="col-12 col-md-6 mt-3"
    >
      <div class="list-row d-flex align-items-center justify-content-between">
        <div
          class="list-row-content d-flex align-items-center cursor-pointer"
          @click="navigate(option, $event)"
        >
          <img
            class="list-row-icon rounded-circle"
            :src="showImage(option.mainImage)"
          />
          <span class="list-row-title">{{ option.title }}</span>
        </div>
        <span v-if="showStar" class="star font-20">
          <div v-if="!option.isFavorite">
            <i
              class="fas fa-star fill cursor-pointer"
              @click="$emit('add', option)"
            />
            <i class="far fa-star unfill cursor-pointer" />
          </div>
          <div v-else>
            <i
              class="fas fa-star text-warning cursor-pointer"
              @click="$emit('remove', option)"
            />
          </div>
        </span>
      </div>
    </div>
  </div>
  <div v-else class="row">
    <div class="col-12 flip-cards-container  pr-0 pl-0 ">
      <div
        v-for="(option, index) in menu"
        :key="index"
        class="flip-card col-lg-3 col-md-6 mt-4 col-6"
        :class="rotateCard(option) ? 'card-rotate' : ''"
      >
        <div class="flip-card-inner">
          <div>
            <div class="flip-card-front">
              <span
                v-if="showStar"
                class="star font-20 d-flex justify-content-end mr-3 mt-2"
              >
                <div v-if="!option.isFavorite">
                  <i
                    class="fas fa-star fill cursor-pointer"
                    @click="$emit('add', option)"
                  />
                  <i class="far fa-star unfill cursor-pointer" />
                </div>
                <div v-else>
                  <i
                    class="fas fa-star text-warning cursor-pointer"
                    @click="$emit('remove', option)"
                  />
                </div>
              </span>
              <div class="text-decorator">
                <div class="col-xs-7">
                  <img
                    class="rounded-circle"
                    :src="showImage(option.mainImage)"
                  />
                  <h3 class="card-front-title">
                    {{ option.title }}
                  </h3>
                  <p class="px-4 card-front-p mb-3">
                    {{ option.description }}
                  </p>
                </div>
              </div>
            </div>
            <div class="flip-card-back cursor-pointer">
              <span
                v-if="showStar"
                class="star font-20 d-flex justify-content-end mr-3 mt-2 mb-5 float-right"
              >
                <div v-if="!option.isFavorite">
                  <i
                    class="fas fa-star fill cursor-pointer"
                    @click="$emit('add', option)"
                  />
                  <i class="far fa-star unfill cursor-pointer" />
                </div>
                <div v-else>
                  <i
                    class="fas fa-star text-warning cursor-pointer"
                    @click="$emit('remove', option)"
                  />
                </div>
              </span>
              <div
                :class="showStar ? 'back-content-with-start' : ''"
                @click="navigate(option, $event)"
              >
                <div v-if="!showStar" class="text-right">
                  <img
                    class="rounded-circle"
                    :src="showImage(option.hoverImage)"
                  />
                </div>
                <h3 class="px-4 card-back-title">
                  {{ option.title }}
                </h3>
                <p class="card-back-p px-4 pb-2">
                  {{ option.detail }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import cardRoutes from '@/utils/constants/cardRoutes.js';
import { SECURITY_URL } from '@/config';

export default {
  name: 'SquareOption',
  meta: {
    description: 'Componente común de opciones en tarjeta ',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    menu: {
      type: Array,
      default: () => [
        {
          description: undefined,
          detail: undefined,
          hoverImage: undefined,
          icon: undefined,
          mainImage: undefined,
          needSelectedStudent: undefined,
          route: undefined,
          title: undefined,
          canNavigate: false,
          trackingFlag: false,
        },
      ],
      meta: {
        description: 'Establece las opciones del SquareOption',
        example: 'this.SquareData',
      },
    },
    showStar: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: String,
      default: 'grid',
      validator: (value) => ['grid', 'list'].includes(value),
    },
  },
  computed: {
    rotateCard() {
      return (item) => {
        return item.rotate == undefined ? true : item.rotate;
      };
    },
  },
  methods: {
    async navigate(option, event) {
      //BC: security portal redirect
      if (option.route === cardRoutes.UserRequest) {
        window.open(SECURITY_URL, '_blank');
        return;
      }

      if (await option.canNavigate(option)) {
        // JSF: if the route start with http then it must redirect to that site.
        if (option.route.indexOf('http') !== -1) {
          window.location.href = option.route;
          return;
        }

        /** This option works when student is selected (second time) */
        this.$router.push(option.route).catch(() => {});
      }
      event.stopImmediatePropagation();
    },
    showImage(imgName) {
      try {
        return require(`@/assets/img/${imgName}`);
      } catch {
        return require('@/assets/img/logo.png'); //Imagen por default
      }
    },
  },
};
</script>

<style scoped>
.text-decorator {
  text-decoration: none;
}
.option-title {
  font-size: 12.5px;
}
.menu-item {
  height: 115px;
  width: 225px;
}

/**12/16/2019 flip card effect**/
.flip-card {
  background-color: transparent;
  height: auto;
  perspective: 1000px; /* Remove this if you don't want the 3D effect */

  /*Other browsers*/
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -o-perspective: 1000;
  -ms-perspective: 1000;
  perspective: 1000;

  -ms-transform: perspective(1000px);
  -moz-transform: perspective(1000px);
  -moz-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
}

/* This container is needed to position the front and back side */
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;

  /*Other browsers*/
  -webkit-transition: 0.8s;
  -webkit-transform-style: preserve-3d;
  -ms-transition: 0.8s;

  -moz-transition: 0.8s;
  -moz-transform: perspective(1000px);
  -moz-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;

  transition: 0.8s;
  transform-style: preserve-3d;

  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
}

/* Do an horizontal flip when you move the mouse over the flip box container */
.flip-card.card-rotate:hover .flip-card-back,
.flip-card.card-rotate.hover .flip-card-back {
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  transform: rotateY(0deg);
}

.flip-card.card-rotate:hover .flip-card-front,
.flip-card.card-rotate.hover .flip-card-front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
/* Position the front and back side */
.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 210px !important;
  backface-visibility: hidden;

  /*Other browsers*/
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;

  -webkit-transition: 0.8s;
  -webkit-transform-style: preserve-3d;

  -moz-transition: 0.8s;
  -moz-transform-style: preserve-3d;

  -o-transition: 0.8s;
  -o-transform-style: preserve-3d;

  -ms-transition: 0.8s;
  -ms-transform-style: preserve-3d;

  transition: 0.8s;
  transform-style: preserve-3d;
}

/* Style the front side (fallback if image is missing) */
.flip-card-front {
  background: transparent linear-gradient(180deg, #ffffff 0%, #f2f2f2 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  color: black;
  height: auto;
  height: 210px !important;

  -webkit-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
}

.card-front-title {
  color: #2db782;
  margin-top: -30px;
  font: Bold 14px/17px Lato;
}

.card-front-p {
  font: 12px/16px Lato;
  letter-spacing: 0;
  color: black;
}

.card-back-title {
  color: white;
  font: Bold 14px/17px Lato;
  margin-top: -10px;
}

.card-back-p {
  font: 12px Lato;
  letter-spacing: 0;
  color: #ffffff;
}

/* Style the back side */
.flip-card-back {
  background-image: linear-gradient(to top, #007a50, #02b47d);
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3c7552;
  border-radius: 5px;
  color: white;
  height: auto;

  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(-180deg);
}
.cursor-pointer {
  cursor: pointer;
}
/**End of flip card effect**/

.flip-cards-container {
  display: flex;
  flex-wrap: wrap;
}

.flip-cards-container > div {
  min-height: 200px;
  min-width: 200px;
}

.unfill {
  color: #b5c3bc;
}

.fill {
  color: #f8b539;
}

.star:hover .unfill,
.star .fill {
  display: none;
}

.star:hover .fill {
  display: inline;
}

.back-content-with-start {
  width: 100%;
  height: 100%;
  padding-top: 90px;
}

.list-row {
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  box-shadow: 0px 3px 6px #00000014;
  padding: 10px 20px;
  min-height: 64px;
}

.list-row-content {
  flex: 1;
}

.list-row-icon {
  width: 36px;
  height: 36px;
  margin-right: 12px;
  object-fit: cover;
}

.list-row-title {
  font: Bold 14px/17px Lato;
  color: #11291b;
  text-align: left;
}
</style>
